export default __webpack_public_path__ + "static/media/CarDetailingHeavyCut.99412809.jpg";